import { AnimatePresence, motion } from 'motion/react'
import { useEffect, useRef } from 'react'
import cx from 'classnames'

const sizeTypeToClasses: Record<'lg' | 'md' | 'sm' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl', string> =
  {
    lg: 'max-w-lg',
    md: 'max-w-md',
    sm: 'max-w-sm',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl'
  }

export default function Drawer({
  isOpen = false,
  sizeType = '2xl',
  close = () => {},
  children
}: {
  isOpen: boolean
  sizeType?: 'lg' | 'md' | 'sm' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl'
  close: () => void
  children: React.ReactNode
}) {
  const originalOverflow = useRef<string>('')

  useEffect(() => {
    if (isOpen) {
      // Store the original overflow value
      originalOverflow.current = document.body.style.overflow || ''
      document.body.style.overflow = 'hidden'
    } else {
      // Restore the original overflow value when closing
      document.body.style.overflow = originalOverflow.current || ''
    }

    // Cleanup function to ensure overflow is restored on unmount
    return () => {
      document.body.style.overflow = originalOverflow.current || ''
    }
  }, [isOpen])
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ x: '100%' }}
            animate={{
              x: 0
            }}
            exit={{
              x: '100%'
            }}
            transition={{ type: 'spring', bounce: 0, duration: 0.4 }}
            className={cx(
              'fixed bg-white text-black shadow-lg top-0 right-0 w-full h-screen z-50',
              sizeTypeToClasses[sizeType]
            )}
          >
            {children}
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1
            }}
            exit={{
              opacity: 0
            }}
            transition={{ type: 'spring', bounce: 0, duration: 0.2 }}
            onClick={() => close()}
            className="bg-black/50 px-5 fixed h-full w-full flex items-center justify-center top-0 left-0 z-40"
          />
        </>
      )}
    </AnimatePresence>
  )
}
